import React from "react";

const ChemistryBlock = ({ block }) => {
    return (
        <div
            style={{
                margin: "20px 0",
                textAlign: "center",
                fontSize: 24,
                fontFamily: "serif",
                whiteSpace: "pre-wrap",
            }}
        >
            {block.formula || ""}
        </div>
    );
};

export default ChemistryBlock;